import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=55263a34"
import script from "./Expediente.vue?vue&type=script&lang=js"
export * from "./Expediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55263a34')) {
      api.createRecord('55263a34', component.options)
    } else {
      api.reload('55263a34', component.options)
    }
    module.hot.accept("./Expediente.vue?vue&type=template&id=55263a34", function () {
      api.rerender('55263a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/Expediente.vue"
export default component.exports